import React, { useState } from "react";
import {
  deleteBaseText,
  updateBaseText,
} from "../../services/referenceQuestionnaireService";
import { ReferenceQuestionnaire } from "../../interfaces/referenceQuestionnaire";
import { updateBaseTextCandidate } from "../../services/candidateQuestionnaireService";
import {
  updateBaseTextReferenceAuthorization,
  updateInstructionsReferenceAuthorization,
} from "../../services/referenceAuthorizationService";
import { ReferenceAuthorization } from "../../interfaces/referenceAuthorization";
import { ReferenceAuthorizationInstruction } from "../../interfaces/referenceAuthorizationInstruction";

interface EditBaseTextProps {
  type: string;
  clientID: number;
  baseTextKey:
    | keyof ReferenceQuestionnaire
    | keyof ReferenceAuthorization
    | keyof ReferenceAuthorizationInstruction;
  baseText: string;
  onClose: (updatedText?: string, successMessage?: string) => void;
}

const EditBaseText: React.FC<EditBaseTextProps> = ({
  type,
  clientID,
  baseTextKey,
  baseText,
  onClose,
}) => {
  const [editedText, setEditedText] = useState(baseText);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [loadingSpinner, setLoadingSpinner] = useState(false);

  const handleSaveBaseText = async () => {
    try {
      setLoadingSpinner(true);

      if (editedText) {
        if (type === "reference") {
          await updateBaseText(
            clientID,
            baseTextKey as keyof ReferenceQuestionnaire,
            editedText,
          );
          onClose(editedText, "Text updated successfully");
        } else if (type === "candidate") {
          await updateBaseTextCandidate(
            clientID,
            baseTextKey as keyof ReferenceQuestionnaire,
            editedText,
          );
          onClose(editedText, "Text updated successfully");
        } else if (type === "referenceAuthorization") {
          await updateBaseTextReferenceAuthorization(
            clientID,
            baseTextKey as keyof ReferenceAuthorization,
            editedText,
          );
          onClose(editedText, "Text updated successfully");
        } else if (type === "referenceAuthorizationInstruction") {
          await updateInstructionsReferenceAuthorization(
            clientID,
            baseTextKey as keyof ReferenceAuthorizationInstruction,
            editedText,
          );
          onClose(editedText, "Text updated successfully");
        }
        setErrorMessage("");
      }
    } catch (error) {
      console.error("Error updating text:", error);
      setErrorMessage("");
    } finally {
      setLoadingSpinner(false);
    }
  };

  const handleDeleteBaseText = async () => {
    try {
      setLoadingSpinner(true);
      await deleteBaseText(
        clientID,
        baseTextKey as keyof ReferenceQuestionnaire,
      );
      onClose("", "Text deleted successfully");
      setErrorMessage("");
    } catch (error) {
      console.error("Error deleting text:", error);
      setErrorMessage("");
    } finally {
      setLoadingSpinner(false);
    }
  };

  return (
    <>
      <div className="background-mask" onClick={() => onClose(baseText)}></div>
      <div className="filter-popup-large">
        <div className="close-button-container">
          <button className="close-button" onClick={() => onClose(baseText)}>
            <i className="bi bi-x-circle"></i>
          </button>
        </div>
        <div className="filter-header">
          <h2>Edit Text</h2>
        </div>
        <br></br>
        <div
          className="dialog-container"
          style={{ flexDirection: "row", flexWrap: "wrap" }}
        >
          <textarea
            value={editedText}
            onChange={(e) => setEditedText(e.target.value)}
            rows={6}
            style={{ width: "100%" }}
            maxLength={1000}
          />
          <div
            style={{
              fontSize: "14px",
              textAlign: "right",
              width: "100%",
            }}
          >
            {editedText?.length ?? 0}/1000
          </div>
          {errorMessage && (
            <div className="error-message red" style={{ color: "red" }}>
              {errorMessage}
            </div>
          )}
        </div>
        <div className="filter-actions">
          <button className={`oxbtn btn-green`} onClick={handleSaveBaseText}>
            Save
          </button>
          {type === "reference" && (
            <button className={`oxbtn btn-red`} onClick={handleDeleteBaseText}>
              Delete
            </button>
          )}
        </div>
      </div>
      {loadingSpinner && (
        <div className="loading-mask">
          <div className="loading-spinner"></div>
        </div>
      )}
    </>
  );
};

export default EditBaseText;
